import angular from 'angular';
import ngRoute from 'angular-route';
import booksMenu from '../../menu/Menu';
import './App.scss';
/** Store Account Management */
import { storeAccountManagementComponent } from './storeAccountManagement';
/** Services */
import { StoreAccountManagementProvider } from './Services/StoreAccountManagement';
/** Dialogs */
import { AddEmailAddressDialogService } from './dialogs/addEmailAddressDialog';

/*******************************************************************************
 * @ngdoc  overview
 * @module csm.books.StoreAdmin
 * @description
 * Base module of the ASB Works/myPTEZ/Booster Finance webstore admin application.
 *******************************************************************************/
export default angular
  .module('csm.books.StoreAccountManagement', [
    booksMenu,
    ngRoute
  ])
  .component('storeAccountManagement', storeAccountManagementComponent)
  .provider('StoreAccountManagement', StoreAccountManagementProvider)
  .service('addEmailAddressDialog', AddEmailAddressDialogService)
  .name;
